import type { Sport } from '@painpal/contracts';
import type { SportFilter, ZoneSource } from '../../api/keys';
import { SPORT_META, sportNoun } from '../../lib/sports';

export const COMBINED_NOTE = 'FITNESS, FATIGUE AND FORM ALWAYS COMBINE ALL SPORTS · THE FILTER LIMITS LOAD BARS, THE WEEK AND TIME IN ZONE';
export const COMBINED_CHIP = 'FITNESS · FATIGUE · FORM = ALL SPORTS';

export const filterOptions = (sports: readonly Sport[]): SportFilter[] => ['all', ...sports];
export const filterLabel = (filter: SportFilter): string => (filter === 'all' ? 'ALL' : SPORT_META[filter].label);
export const fitnessSearch = (filter: SportFilter): { sport?: Sport } => (filter === 'all' ? {} : { sport: filter });

export const phoneNote = (sport: Sport): string =>
  `${filterLabel(sport)} ONLY: LOAD BARS, THIS WEEK, TIME IN ZONE. FITNESS, FATIGUE AND FORM STAY ALL SPORTS.`;

// Power belongs to rides and pace to runs; HR applies to every sport.
export function zoneSources(filter: SportFilter, sports: readonly Sport[]): [ZoneSource, ...ZoneSource[]] {
  if (filter === 'ride') return ['power', 'hr'];
  if (filter === 'run') return ['pace', 'hr'];
  if (filter !== 'all') return ['hr'];
  return sports.includes('ride') ? ['power', 'hr'] : ['hr'];
}

export const pluralNoun = (filter: SportFilter): string => sportNoun(filter, 2);

export const onlyLabel = (sport: Sport): string => `${pluralNoun(sport)} ONLY`;
